module.exports = __webpack_public_path__ + "static/img/03_02_multi_comp.f285ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/03_02_multi_comp.png
// module id = NZ8P
// module chunks = 13